module.exports = __webpack_public_path__ + "media/assets/images/landing/соц. пособия-a4cd1c0926206b16c7c5dab1e4ec5eeb.png";